/* eslint-disable eqeqeq */
import React from 'react';

export const PropertyUsePropertyTypeGroup = ({
  handlePropertyTypeGroup,
  propertyTypeGroupId,
  propertyUseInPropertyTypeGroup,
}) => {
  return (
    <div className="property-filter-block">
      {propertyUseInPropertyTypeGroup && (
        <label className="property-details-label">
          Property Type Group
        </label>
      )}
      <div className="property-pill-grid">
        {propertyUseInPropertyTypeGroup &&
          React.Children.toArray(
            propertyUseInPropertyTypeGroup?.map((propertyTypeGroup) => (
              <button
                type="button"
                key={propertyTypeGroup?.id}
                className={`property-pill ${
                  propertyTypeGroupId == propertyTypeGroup?.id
                    ? 'property-pill--active'
                    : ''
                }`}
                onClick={handlePropertyTypeGroup}
                data-propertytypegroup={propertyTypeGroup?.id}
              >
                {propertyTypeGroup?.description}
              </button>
            )),
          )}
      </div>
    </div>
  );
};
